export const initializePendo = (
  visitorData: {
    id: string | number
    email?: string
    full_name?: string
    role?: string
  },
  accountData: {
    id: string | number
    name?: string
    is_paying?: boolean
    planLevel?: string
    creationDate?: string
  }
) => {
  const maxWaitTime = 5 * 60 * 1000 // 5 minutes
  const intervalTime = 100
  let elapsed = 0

  const interval = setInterval(() => {
    if (window.pendo && typeof window.pendo.initialize === 'function') {
      clearInterval(interval)
      //console.log('Pendo agent is ready. Initializing...')
      window.pendo.initialize({
        visitor: visitorData,
        account: accountData,
      })
    } else {
      elapsed += intervalTime
      if (elapsed >= maxWaitTime) {
        clearInterval(interval)
        //console.warn(`Pendo agent was not ready after ${maxWaitTime / 60000} minutes. Initialization aborted.`)
      } else {
        //console.log('Waiting for Pendo agent...')
      }
    }
  }, intervalTime)
}
